import React, { useRef, useEffect } from "react"
// import { translate } from "@fulcrum/lib";
require("@connect/group-picker/build/group-picker")

export interface IGroupPicker {
  onChange: (event: Event, which: string) => void
  apiUrl: string
  id: string
  selectionList: string[]
}

const GroupPicker = ({ onChange, apiUrl, id, selectionList }: IGroupPicker) => {
  const ref = useRef<HTMLInputElement>(null)
  const ACCESS_TOKEN = localStorage.getItem("tc-access-token")

  useEffect(() => {
    //Hook's version of ComponentDidMount
    if (ref.current) {
      ref.current.addEventListener("selection-changed", (e: Event) => onChange(e, "group-picker"))
    }

    //Hook's version of ComponentWillUnmount
    return () => {
      if (ref.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ref.current.removeEventListener("selection-changed", (e: Event) => onChange(e, "group-picker"))
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // const translationSource = [
  //   {
  //     type: "DICTIONARY",
  //     value: {
  //       Label: translate("TC.Common.Groups"),
  //       SearchPlaceHolder: translate("TC.Search.Groups.PlaceholderText"),
  //       LastUpdated: translate("TC.Common.LastUpdated"),
  //       NoResults: translate("noResults"),
  //     },
  //   },
  // ];

  const translationSource = [
    {
      type: "DICTIONARY",
      value: {
        Label: "Groups",
        SearchPlaceHolder: "Search groups",
        LastUpdated: "Last Updated",
        NoResults: "No results found"
      }
    }
  ]

  return (
    <group-picker
      ref={ref}
      selection-list={`${JSON.stringify(selectionList)}`}
      id={id}
      api-url={apiUrl}
      access-token={ACCESS_TOKEN}
      translation-source={JSON.stringify(translationSource)}
    />
  )
}

export default React.memo(GroupPicker)
